import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { catchError, EMPTY, map, Observable, of } from 'rxjs';
import { UserProfile } from 'src/app/models/userProfile';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class UserProfileResolver  {

	constructor(
		private readonly _authService: AuthService,
		private readonly _router: Router
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserProfile> {
		return this._authService.getUserProfile()
			.pipe(
				map((v) => {
					return v.data;
				}),
				catchError((e) => {
					this._router.navigate(["/"]);
					return EMPTY;
				})
			);
	}
}
